import { WeaTools } from 'ecCom'

export const readBirthdayBlessingData = (params = {}) => {
    return WeaTools.callApi('/api/hrm/birthday/readBirthdayBlessingData', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/blessCard.js